import { useState } from 'react'
import { Video } from 'lucide-react'
import Button from '@/components/ui/Button'

interface SignLanguageButtonProps {
  videoUrl?: string
  onPlay?: () => void
}

export default function SignLanguageButton({ videoUrl, onPlay }: SignLanguageButtonProps) {
  const [isOpen, setIsOpen] = useState(false)

  if (!videoUrl) {
    return null
  }

  const handleClick = () => {
    if (onPlay) {
      onPlay()
    }
    setIsOpen(true)
  }

  return (
    <>
      <Button variant="secondary" size="sm" onClick={handleClick} className="flex items-center gap-2">
        <Video className="w-4 h-4" />
        لغة الإشارة
      </Button>

      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
          <div className="relative bg-white dark:bg-gray-800 rounded-lg w-full max-w-4xl">
            <div className="absolute top-4 right-4 z-10">
              <button
                onClick={() => setIsOpen(false)}
                className="bg-white dark:bg-gray-700 rounded-full p-2 hover:bg-gray-100 dark:hover:bg-gray-600 transition-colors shadow-lg"
                aria-label="إغلاق"
                title="إغلاق"
              >
                <span className="text-2xl font-bold text-gray-700 dark:text-gray-300">×</span>
              </button>
            </div>
            <div className="p-4">
              <video
                src={videoUrl}
                controls
                className="w-full rounded-lg"
                autoPlay
                onEnded={() => setIsOpen(false)}
                onError={(e) => {
                  console.error('Video playback error:', e)
                  // Show error message or handle gracefully
                }}
              >
                متصفحك لا يدعم تشغيل الفيديو
              </video>
            </div>
          </div>
        </div>
      )}
    </>
  )
}


